import * as _ from 'lodash';
import { DropdownOption } from '../../definitions/formItem/ElementConfig';
var Variant = /** @class */ (function () {
    function Variant(obj, id) {
        if (id) {
            this.id = id;
        }
        this.old_price = obj.old_price;
        this.price = obj.price;
        this.status = obj.status;
        this.barcode = obj.barcode;
        this.default = obj.default;
        this.use_as_main_in_list = obj.use_as_main_in_list;
        this.packaging = obj.packaging;
        this.bg_composition = obj.bg_composition;
        this.en_composition = obj.en_composition;
        this.position = obj.position;
        // might not be the best way but... ¯\_(ツ)_/¯
        this.option_value_name = _.get(obj, 'option_value.attributes.value', _.get(obj, 'option_value.label'));
        this.option_value_id = _.get(obj, 'option_value.id', _.get(obj, 'option_value.value'));
        // this.option_value = _.get(obj, 'option_value.id', _.get(obj, 'option_value'));
        this.external_id = _.get(obj, 'external_id', '');
        this.gifts_formatted = obj.gift
            ? new DropdownOption({
                label: _.get(obj, 'gift.attributes.name'),
                value: _.get(obj, 'gift.id'),
            })
            : null;
        this.gift_id = _.get(obj, 'gift.id', _.get(obj, 'gift'));
        this.stock_status = _.get(obj, 'stock_status', '');
    }
    Object.defineProperty(Variant.prototype, "Price", {
        get: function () {
            return this.price;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "OldPrice", {
        get: function () {
            return this.old_price;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "Status", {
        get: function () {
            return this.status;
        },
        set: function (status) {
            this.status = status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "StockStatus", {
        get: function () {
            return this.stock_status;
        },
        set: function (stockstatus) {
            this.stock_status = stockstatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "Barcode", {
        get: function () {
            return this.barcode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "Default", {
        get: function () {
            return this.default;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "UseAsMainInList", {
        get: function () {
            return this.use_as_main_in_list;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "Packaging", {
        get: function () {
            return this.packaging;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "BgComposition", {
        get: function () {
            return this.bg_composition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "EnComposition", {
        get: function () {
            return this.en_composition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "GiftsFormatted", {
        get: function () {
            return this.gifts_formatted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "Position", {
        /* public get Gift(): number | null {
            return this.gift;
        } */
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "OptionValueName", {
        get: function () {
            return this.option_value_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "OptionValueId", {
        get: function () {
            return this.option_value_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "Gift", {
        get: function () {
            return this.gift_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Variant.prototype, "ExternalId", {
        get: function () {
            return this.external_id;
        },
        set: function (id) {
            this.external_id = id;
        },
        enumerable: false,
        configurable: true
    });
    return Variant;
}());
export { Variant };
export function createVariant(obj, id) {
    return new Variant(obj, id);
}
export function createVariants(rawVariants) {
    var variants = [];
    var rawVariantsData = rawVariants.data;
    for (var _i = 0, rawVariantsData_1 = rawVariantsData; _i < rawVariantsData_1.length; _i++) {
        var rawVariant = rawVariantsData_1[_i];
        var variant = createVariant(rawVariant.attributes, rawVariant.id);
        variants.push(variant);
    }
    return variants;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/product/variant.ts
// module id = 138
// module chunks = 0